import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Helmet } from "react-helmet-async";
import "./StateCards.css";

import AndamanandNicobar from "../../../assets/StateCardImage/AndamanandNicobar.jpeg";
import AndhraPradesh from "../../../assets/StateCardImage/AndhraPradesh.jpg";
import ArunachalPradesh from "../../../assets/StateCardImage/ArunachalPradesh.jpg";
import Assam from "../../../assets/StateCardImage/Assam.jpg";
import Bihar from "../../../assets/StateCardImage/Bihar.jpg";
import Chandigarh from "../../../assets/StateCardImage/Chandigarh.jpeg";
import Chhattisgarh from "../../../assets/StateCardImage/Chhattisgarh.jpg";
import DadraandNagarHaveliandDamanandDiu from "../../../assets/StateCardImage/DadraandNagarHaveliandDamanandDiu.jpg";
import Delhi from "../../../assets/StateCardImage/Delhi.jpg";
import Goa from "../../../assets/StateCardImage/Goa.jpg";
import Gujarat from "../../../assets/StateCardImage/Gujarat.jpg";
import Haryana from "../../../assets/StateCardImage/Haryana.jpg";
import HimachalPradesh from "../../../assets/StateCardImage/HimachalPradesh.jpg";
import JammuandKashmir from "../../../assets/StateCardImage/JammuandKashmir.jpg";
import Jharkhand from "../../../assets/StateCardImage/Jharkhand.jpg";
import Karnataka from "../../../assets/StateCardImage/Karnataka.jpg";
import Kerala from "../../../assets/StateCardImage/Kerala.jpg";
import Ladakh from "../../../assets/StateCardImage/Ladakh.jpg";
import Maharashtra from "../../../assets/StateCardImage/Maharashtra.jpg";
import Manipur from "../../../assets/StateCardImage/Manipur.jpg";
import Meghalaya from "../../../assets/StateCardImage/Meghalaya.jpg";
import Mizoram from "../../../assets/StateCardImage/Mizoram.jpg";
import Odisha from "../../../assets/StateCardImage/Odisha.jpg";
import Punjab from "../../../assets/StateCardImage/Punjab.jpg";
import Rajasthan from "../../../assets/StateCardImage/Rajasthan.jpg";
import Sikkim from "../../../assets/StateCardImage/Sikkim.jpg";
import TamilNadu from "../../../assets/StateCardImage/TamilNadu.jpeg";
import Telangana from "../../../assets/StateCardImage/Telangana.jpg";
import Tripura from "../../../assets/StateCardImage/Tripura.jpg";
import UttarPradesh from "../../../assets/StateCardImage/UttarPradesh.jpg";
import Uttarakhand from "../../../assets/StateCardImage/Uttarakhand.jpg";
import WestBengal from "../../../assets/StateCardImage/WestBengal.jpg";
import Lakshadweep from "../../../assets/StateCardImage/Lakshadweep.jpg";
import MadhyaPradesh from "../../../assets/StateCardImage/MadhyaPradesh.jpg";
import Nagaland from "../../../assets/StateCardImage/Nagaland.jpg";
import Puducherry from "../../../assets/StateCardImage/Puducherry.jpg";

const states = [
  { name: "Andaman and Nicobar", image: AndamanandNicobar },
  { name: "Andhra Pradesh", image: AndhraPradesh },
  { name: "Arunachal Pradesh", image: ArunachalPradesh },
  { name: "Assam", image: Assam },
  { name: "Bihar", image: Bihar },
  { name: "Chandigarh", image: Chandigarh },
  { name: "Chhattisgarh", image: Chhattisgarh },
  {
    name: "Dadra and Nagar Haveli and Daman and Diu",
    image: DadraandNagarHaveliandDamanandDiu,
  },
  { name: "Delhi", image: Delhi },
  { name: "Goa", image: Goa },
  { name: "Gujarat", image: Gujarat },
  { name: "Haryana", image: Haryana },
  { name: "Himachal Pradesh", image: HimachalPradesh },
  { name: "Jammu and Kashmir", image: JammuandKashmir },
  { name: "Jharkhand", image: Jharkhand },
  { name: "Karnataka", image: Karnataka },
  { name: "Kerala", image: Kerala },
  { name: "Ladakh", image: Ladakh },
  { name: "Lakshadweep", image: Lakshadweep },
  { name: "Madhya Pradesh", image: MadhyaPradesh },
  { name: "Maharashtra", image: Maharashtra },
  { name: "Manipur", image: Manipur },
  { name: "Meghalaya", image: Meghalaya },
  { name: "Mizoram", image: Mizoram },
  { name: "Nagaland", image: Nagaland },
  { name: "Odisha", image: Odisha },
  { name: "Puducherry", image: Puducherry },
  { name: "Punjab", image: Punjab },
  { name: "Rajasthan", image: Rajasthan },
  { name: "Sikkim", image: Sikkim },
  { name: "Tamil Nadu", image: TamilNadu },
  { name: "Telangana", image: Telangana },
  { name: "Tripura", image: Tripura },
  { name: "Uttar Pradesh", image: UttarPradesh },
  { name: "Uttarakhand", image: Uttarakhand },
  { name: "West Bengal", image: WestBengal },
];

const StateCards = () => {
  return (
    <div className="state-page">
      {/* ✅ SEO Meta */}
      <Helmet>
        <title>State Governing Bodies | Manav Adhikar Forum</title>
        <meta
          name="description"
          content="Explore the state governing bodies of the Manav Adhikar Forum across India."
        />
      </Helmet>

      {/* ✅ Hero Section */}
      <div className="state-hero">
        <div className="d-flex flex-column mb-1 text-center align-items-center">
          <h1 className="fw-bold" style={{ color: "#1a5276" }}>
            State Governing Bodies
            <div
              className="rounded-pill mt-2 bg-warning"
              style={{
                height: "5px",
                width: "15%",
              }}
            ></div>
          </h1>
        </div>
        <p>
          Discover the leadership and members of our forum across different
          states in India.
        </p>
      </div>

      {/* ✅ Grid */}
      <div className="state-cards-container">
        {states.map((state, idx) => (
          <a
            key={idx}
            href={`/States?State=${state.name.replace(/\s+/g, "-")}`}
            className="state-card"
          >
            <div className="state-card-media">
              {/* ✅ Lazy load image */}
              <LazyLoadImage
                src={state.image}
                alt={`${state.name} State Governing Body`}
                effect="blur"
                className="state-card-img"
              />
              <div className="state-card-overlay"></div>
              <h2 className="state-name">{state.name}</h2>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default StateCards;
